<template>
  <component v-if="!loaded" :is="componentSeleted"></component>

  <template v-else-if="!information">
    <slot name="noData">
      <div
        class="no-data-info d-flex justify-content-center align-items-center"
      >
        <i v-if="showNoDataIcon" :class="noDataIcon" />
        <span class="ms-3">{{ noDataText }}</span>
      </div>
    </slot>
  </template>

  <slot v-else />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SkeletonTableNave from "@/components/atomic/atoms/skeletons/skeletonTableNave.vue";
import SkeletonNaveCard from "@/components/atomic/atoms/skeletons/skeletonCardNave.vue";
import SkeletonGraph from "@/components/atomic/atoms/skeletons/skeletonGraphNave.vue";
import SkeletonRevenuePageNave from "@/components/atomic/atoms/skeletons/skeletonRevenuePageNave.vue";
import SkeletonInsightsPageNave from "@/components/atomic/atoms/skeletons/skeletonInsightsPageNave.vue";
import SkeletonTextNumber from "@/components/atomic/atoms/skeletons/skeletonTextNumber.vue";
import skeletonCreateAudience from "@/components/atomic/atoms/skeletons/skeletonCreateAudience.vue";
import skeletonTitle from "@/components/atomic/atoms/skeletons/skeletonTitle.vue";
import skeletonDate from "@/components/atomic/atoms/skeletons/skeletonDate.vue";
import skeletonLineText from "@/components/atomic/atoms/skeletons/skeletonLineText.vue";
import skeletonSelectAudienceList from "@/components/atomic/atoms/skeletons/skeletonSelectAudienceList.vue";
import skeletonCardsAction from "@/components/atomic/atoms/skeletons/skeletonCardsAction.vue";

interface ICompoentList {
  table: any;
  card: any;
  graph: any;
  revenue: any;
  insights: any;
  textNumber: any;
  createAudience: any;
  title: any;
  date: any;
  lineText: any;
  cardAction: any;
  [name: string]: any;
}

const componentList = {
  table: SkeletonTableNave,
  card: SkeletonNaveCard,
  graph: SkeletonGraph,
  revenue: SkeletonRevenuePageNave,
  insights: SkeletonInsightsPageNave,
  textNumber: SkeletonTextNumber,
  createAudience: skeletonCreateAudience,
  title: skeletonTitle,
  date: skeletonDate,
  lineText: skeletonLineText,
  selectAudienceList: skeletonSelectAudienceList,
  cardAction: skeletonCardsAction,
} as ICompoentList;

export default defineComponent({
  props: {
    name: {
      type: String,
      default: "table",
    },
    loaded: {
      type: Boolean,
      required: true,
    },
    information: {
      type: Boolean,
      required: true,
    },
    noDataText: {
      type: String,
      default: "Não existem dados no período selecionado",
    },
    noDataIcon: {
      type: String,
      default: "icon-nav-empty",
    },
    showNoDataIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    componentSeleted() {
      return componentList[this.name];
    },
  },
});
</script>

<style lang="scss" scoped>
.no-data-info {
  font-family: "text-medium";
  color: #989898;
  font-size: toRem(19px);
  height: toRem(100px);

  > i {
    color: #989898;
  }
}
</style>
